import React, { useMemo } from 'react';
import Table from '../../common/Table';

const NoteTable = ({ notes, onNoteClick }) => {
    const columns = useMemo(
        () => [
            {
                Header: 'Note',
                accessor: 'content'
            }
        ],
        []
    );

    return <Table columns={columns} data={notes} onRowClick={onNoteClick} />;
};

export default NoteTable;
